import { DataEndpoint } from "../../../../lib/data/remote/DataEndpoint.js";
import { endpoints } from "../core-api-endpoints.js";

export class FileRepositoryManager {

    constructor(authManager = null) {
        this.dataEndpoint = new DataEndpoint(endpoints.fileRepository.root, authManager);
    }

    getDataEndpoint() {
        return this.dataEndpoint;
    }

    async getRootFolder() {
        return this.getDataEndpoint().get();
    }

    async getRootFolderSubfolders() {
        return this.getDataEndpoint().get('folders');
    }

    async getRootFolderFiles() {
        return this.getDataEndpoint().get('files');
    }

    async createRootFolder(data) {
        return this.getDataEndpoint().post('folders', data);
    }

    async getFolder(folderUid) {
        return this.getDataEndpoint().get(`folder/${folderUid}`);
    }

    async updateFolder(folderUid, data) {
        return this.getDataEndpoint().put(`folder/${folderUid}`, data);
    }

    async getFolderSubfolders(folderUid) {
        return this.getDataEndpoint().get(`folder/${folderUid}/folders`);
    }

    async createFolder(folderUid, data) {
        return this.getDataEndpoint().post(`folder/${folderUid}/folders`, data);
    }

    async getFolderFiles(folderUid) {
        return this.getDataEndpoint().get(`folder/${folderUid}/files`);
    }

    async getFolderPermissionContext(folderUid) {
        return this.getDataEndpoint().get(`folder/${folderUid}/permissions/context`);
    }

    async getFolderPermissions(folderUid) {
        return this.getDataEndpoint().get(`folder/${folderUid}/permissions`);
    }

    async createFolderPermission(folderUid, data) {
        return this.getDataEndpoint().post(`folder/${folderUid}/permissions`, data);
    }

    async updateFolderPermission(folderUid, folderPermissionId, data) {
        return this.getDataEndpoint().put(`folder/${folderUid}/permissions/${folderPermissionId}`, data);
    }

    async deleteFolderPermission(folderUid, folderPermissionId) {
        return this.getDataEndpoint().delete(`folder/${folderUid}/permissions/${folderPermissionId}`);
    }

    async detachFolderPermissions(folderUid) {
        return this.getDataEndpoint().post(`folder/${folderUid}/permissions/detach`, {});
    }

    async inheritFolderPermissions(folderUid) {
        return this.getDataEndpoint().post(`folder/${folderUid}/permissions/inherit`, {});
    }

    async getFile(fileUid) {
        return this.getDataEndpoint().get(`file/${fileUid}`);
    }

    async updateFile(fileUid, data) {
        return this.getDataEndpoint().put(`file/${fileUid}`, data);
    }

    async deleteFile(fileUid) {
        return this.getDataEndpoint().delete(`file/${fileUid}`);
    }

    async deleteFolder(folderUid) {
        return this.getDataEndpoint().delete(`folder/${folderUid}`);
    }

    getFileContentUrl(fileUid) {
        return this.getDataEndpoint().createServiceUrl(endpoints.fileRepository.fileContent(fileUid));
    }

}
